module.exports = __webpack_public_path__ + "static/media/webIcons-48_backglass.c738ddf0.png";